import txtIcon from "./logo/txt.png";
import logIcon from "./logo/log.png";
import docIcon from "./logo/doc.png";
import wordIcon from "./logo/word.png";
import pdfIcon from "./logo/pdf.png";
import pptIcon from "./logo/ppt.png";
import pngIcon from "./logo/png.png";
import csvIcon from "./logo/csv.png";
import xlsIcon from "./logo/xls.png";
import xlsxIcon from "./logo/xlsx.png";
import xmlIcon from "./logo/xml.png";
import dbIcon from "./logo/db.png";
import jsIcon from "./logo/js.png";
import cssIcon from "./logo/css.png";
import htmlIcon from "./logo/html.png";
import jsonIcon from "./logo/json.png";
import pythonIcon from "./logo/py.png";
import javaIcon from "./logo/java.png";
import ps1Icon from "./logo/ps1.png";
import batIcon from "./logo/bat.png";
import videoIcon from "./logo/video.png";
import zipIcon from "./logo/zip.png";
import exeIcon from "./logo/exe.png";
import folderIcon from "./logo/pdf.png";
import defaultIcon from "./logo/defaultIcon.png";

const fileIcons = {
  txt: txtIcon,
  log: logIcon,
  doc: docIcon,
  word: wordIcon,
  pdf: pdfIcon,
  ppt: pptIcon,
  png: pngIcon,
  csv: csvIcon,
  xls: xlsIcon,
  xlsx: xlsxIcon,
  xml: xmlIcon,
  db: dbIcon,
  js: jsIcon,
  css: cssIcon,
  html: htmlIcon,
  json: jsonIcon,
  py: pythonIcon,
  java: javaIcon,
  ps1: ps1Icon,
  bat: batIcon,
  video: videoIcon,
  zip: zipIcon,
  exe: exeIcon,
  folder: folderIcon,
  default: defaultIcon,
};

export default fileIcons;
